import React from "react";
import AutoNumberSettingSection from "./AutoNumberSettingSection";
import MFASettingSection from "./MFASettingSection";
import CustomFieldsSettingsSection from "./CustomFieldsSettingsSection";
import { useSelector } from "react-redux";

const OrgSettingsSection = () => {
  const subscription = useSelector((state) => state.subscription.subscription);
  const isCustomFieldsEnabled = subscription?.features?.enable_custom_fields;

  return (
    <>
      <AutoNumberSettingSection />
      <MFASettingSection />
      {isCustomFieldsEnabled && <CustomFieldsSettingsSection />}
    </>
  );
};

export default OrgSettingsSection;
